import { render } from "./HistorialPagosModal.vue?vue&type=template&id=649ddfb4&scoped=true"
import script from "./HistorialPagosModal.vue?vue&type=script&lang=js"
export * from "./HistorialPagosModal.vue?vue&type=script&lang=js"

import "./HistorialPagosModal.vue?vue&type=style&index=0&id=649ddfb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649ddfb4"]])

export default __exports__